var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHelp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12z",
    fill: "#8D9BAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.783 13.849c0-.666.075-1.19.226-1.573a2.46 2.46 0 0 1 .731-1.005c.338-.282.593-.54.766-.772a1.27 1.27 0 0 0 .267-.78c0-.687-.297-1.031-.89-1.031-.273 0-.494.1-.662.3-.169.2-.258.472-.267.814h-2.31c.009-.912.296-1.62.86-2.126.566-.51 1.359-.766 2.38-.766 1.016 0 1.802.235 2.358.704.56.47.841 1.137.841 2.003 0 .378-.075.722-.226 1.032-.15.31-.391.627-.724.95l-.786.732a1.84 1.84 0 0 0-.465.663c-.087.223-.135.508-.144.855h-1.955zm-.28 2.078c0-.338.12-.613.362-.827.246-.22.552-.329.916-.329.365 0 .668.11.91.329.245.214.369.49.369.827 0 .337-.123.615-.37.834-.241.214-.544.321-.909.321-.364 0-.67-.107-.916-.321a1.076 1.076 0 0 1-.362-.834z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.c8e4cbab91c526485fd8eb488c2706b6.svg";
export { ForwardRef as ReactComponent };